(function () {
  "use strict";

  function markWalletReady(root) {
    if (!root) return false;
    var host = root.querySelector("shopify-accelerated-checkout");
    if (!host) return false;
    var painted =
      host.offsetHeight > 20 ||
      (host.shadowRoot &&
        host.shadowRoot.querySelector('iframe, button, [role="button"]'));
    if (painted) {
      root.classList.add("is-wallet-ready");
      return true;
    }
    return false;
  }

  function watchBox(box) {
    if (markWalletReady(box)) return;

    if (typeof MutationObserver === "undefined") {
      window.setTimeout(function () {
        markWalletReady(box);
      }, 1200);
      return;
    }

    var queued = false;
    var observer = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        if (markWalletReady(box)) observer.disconnect();
      });
    });

    // childList only — attributes:true on the wallet subtree is an infinite loop
    observer.observe(box, { childList: true, subtree: true });

    window.setTimeout(function () {
      if (markWalletReady(box)) observer.disconnect();
    }, 1200);
    window.setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  function watch() {
    var boxes = document.querySelectorAll(".product-block--buy-buttons");
    boxes.forEach(watchBox);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watch);
  } else {
    watch();
  }
})();
